// extracted by mini-css-extract-plugin
export default {"item":"RecommendCard_item__y8mMz","active":"RecommendCard_active__1h8m-","icon":"RecommendCard_icon__fpsBK","text":"RecommendCard_text__AFt+T"};